import React from 'react'

export const EHOIcon = ({ className }) => {
  return (
    <svg className={className} x="0px" y="0px" viewBox="0 0 720 720">
      <g>
        <polygon
          points="289.5,412.6 282.4,412.6 282.4,415.4 288.9,415.4 288.9,417.7 282.4,417.7 282.4,421.2 289.8,421.2
        289.8,423.6 279.6,423.6 279.6,410.2 289.5,410.2 289.5,412.6 	"
        />
        <path
          d="M298.4,419.9l1.3,1.3c-0.5,0.3-1,0.4-1.5,0.4c-1.5,0-3.6-0.9-3.6-4.7c0-3.7,2.1-4.7,3.6-4.7
    c1.5,0,3.6,0.9,3.6,4.7c0,1.3-0.2,2.2-0.6,2.9l-1.4-1.3L298.4,419.9L298.4,419.9z M304.8,423l-1.5-1.4c0.8-1,1.4-2.6,1.4-4.8
    c0-6.3-4.7-7-6.4-7c-1.8,0-6.4,0.8-6.4,7c0,6.3,4.7,7,6.4,7c0.8,0,2.2-0.1,3.4-0.9l1.6,1.5L304.8,423L304.8,423z"
        />
        <path
          d="M317.9,418.9c0,3.5-2.1,5-5.5,5c-1.2,0-3.1-0.3-4.2-1.6c-0.7-0.8-1-1.9-1-3.2v-8.9h2.8v8.7
    c0,1.9,1.1,2.7,2.4,2.7c1.9,0,2.7-0.9,2.7-2.6v-8.8h2.9V418.9L317.9,418.9z"
        />
        <path
          d="M325.3,413.2L325.3,413.2l1.7,5.3h-3.4L325.3,413.2L325.3,413.2z M322.9,420.8h4.9l0.9,2.8h3l-4.7-13.4h-3.2
    l-4.8,13.4h2.9L322.9,420.8L322.9,420.8z"
        />
        <polygon points="336.7,421.1 343.3,421.1 343.3,423.6 333.9,423.6 333.9,410.2 336.7,410.2 336.7,421.1 	" />
        <polygon
          points="353.9,417.6 353.9,423.6 351.1,423.6 351.1,410.2 353.9,410.2 353.9,415.3 359.2,415.3 359.2,410.2
    361.9,410.2 361.9,423.6 359.2,423.6 359.2,417.6 353.9,417.6 	"
        />
        <path
          d="M367.3,416.9c0-3.7,2.1-4.7,3.6-4.7c1.5,0,3.6,0.9,3.6,4.7c0,3.7-2.1,4.7-3.6,4.7
    C369.4,421.5,367.3,420.6,367.3,416.9L367.3,416.9z M364.5,416.9c0,6.3,4.7,7,6.4,7c1.8,0,6.4-0.8,6.4-7c0-6.3-4.7-7-6.4-7
    C369.1,409.8,364.5,410.6,364.5,416.9L364.5,416.9z"
        />
        <path
          d="M390.7,418.9c0,3.5-2.1,5-5.5,5c-1.2,0-3.1-0.3-4.2-1.6c-0.7-0.8-1-1.9-1-3.2v-8.9h2.8v8.7
    c0,1.9,1.1,2.7,2.4,2.7c1.9,0,2.7-0.9,2.7-2.6v-8.8h2.9V418.9L390.7,418.9z"
        />
        <path
          d="M395.8,419.4c0,0.7,0.4,2.2,2.8,2.2c1.3,0,2.8-0.3,2.8-1.7c0-1-1-1.3-2.4-1.7l-1.4-0.3c-2.2-0.5-4.3-1-4.3-3.9
    c0-1.5,0.8-4.1,5.1-4.1c4.1,0,5.2,2.7,5.2,4.3H401c-0.1-0.6-0.3-2-2.7-2c-1.1,0-2.3,0.4-2.3,1.6c0,1,0.9,1.3,1.4,1.4l3.3,0.8
    c1.8,0.4,3.5,1.2,3.5,3.6c0,4-4.1,4.4-5.3,4.4c-4.9,0-5.7-2.8-5.7-4.5H395.8L395.8,419.4z"
        />
        <polygon points="409.2,423.6 406.4,423.6 406.4,410.2 409.2,410.2 409.2,423.6 	" />
        <polygon
          points="420.3,410.2 423,410.2 423,423.6 420.2,423.6 414.7,414 414.7,414 414.7,423.6 412.1,423.6
    412.1,410.2 415,410.2 420.3,419.5 420.3,419.5 420.3,410.2 	"
        />
        <path
          d="M432.3,416.4h5.6v7.2H436l-0.3-1.7c-0.7,0.8-1.7,2-4.2,2c-3.2,0-6.1-2.3-6.1-7c0-3.6,2-7.1,6.5-7.1
    c4.1,0,5.7,2.7,5.9,4.5H435c0-0.5-1-2.2-2.9-2.2c-2,0-3.8,1.4-3.8,4.8c0,3.7,2,4.6,3.9,4.6c0.6,0,2.7-0.2,3.2-2.9h-3.1V416.4
    L432.3,416.4z"
        />
        <path
          d="M281.8,437.2c0-3.7,2.1-4.7,3.6-4.7c1.5,0,3.6,0.9,3.6,4.7c0,3.7-2.1,4.7-3.6,4.7
    C284,441.9,281.8,440.9,281.8,437.2L281.8,437.2z M279,437.2c0,6.3,4.7,7,6.4,7c1.8,0,6.4-0.8,6.4-7c0-6.3-4.7-7-6.4-7
    C283.7,430.2,279,430.9,279,437.2L279,437.2z"
        />
        <path
          d="M299.5,436.7v-3.9h2.2c1.7,0,2.5,0.5,2.5,1.8c0,0.6,0,2.1-2.1,2.1H299.5L299.5,436.7z M299.5,439.1h3.2
    c3.6,0,4.3-3.1,4.3-4.3c0-2.6-1.6-4.3-4.2-4.3h-6.1v13.4h2.8V439.1L299.5,439.1z"
        />
        <path
          d="M314.6,436.7v-3.9h2.2c1.7,0,2.5,0.5,2.5,1.8c0,0.6,0,2.1-2.1,2.1H314.6L314.6,436.7z M314.6,439.1h3.2
    c3.6,0,4.3-3.1,4.3-4.3c0-2.6-1.6-4.3-4.2-4.3h-6.1v13.4h2.8V439.1L314.6,439.1z"
        />
        <path
          d="M329.1,437.2c0-3.7,2.1-4.7,3.6-4.7c1.5,0,3.6,0.9,3.6,4.7c0,3.7-2.1,4.7-3.6,4.7
    C331.2,441.9,329.1,440.9,329.1,437.2L329.1,437.2z M326.3,437.2c0,6.3,4.7,7,6.4,7c1.8,0,6.4-0.8,6.4-7c0-6.3-4.7-7-6.4-7
    C330.9,430.2,326.3,430.9,326.3,437.2L326.3,437.2z"
        />
        <path
          d="M346.7,436.4v-3.6h3.5c1.6,0,2,1,2,1.8c0,1.3-0.7,1.8-2.2,1.8H346.7L346.7,436.4z M344,443.9h2.7v-5.2h2.9
    c2.1,0,2.2,0.7,2.2,2.5c0,1.4,0.1,2.1,0.3,2.7h3.1v-0.4c-0.6-0.2-0.6-0.7-0.6-2.7c0-2.5-0.6-2.9-1.7-3.4c1.3-0.4,2.1-1.7,2.1-3.2
    c0-1.2-0.6-3.8-4.2-3.8H344V443.9L344,443.9z"
        />
        <polygon
          points="365.4,443.9 362.6,443.9 362.6,432.9 358.5,432.9 358.5,430.5 369.4,430.5 369.4,432.9 365.4,432.9
    365.4,443.9 	"
        />
        <path
          d="M384.4,439.2c0,3.5-2.1,5-5.5,5c-1.2,0-3-0.3-4.2-1.6c-0.7-0.8-1-1.9-1-3.2v-8.9h2.8v8.7
    c0,1.9,1.1,2.7,2.4,2.7c1.9,0,2.7-0.9,2.7-2.6v-8.8h2.9V439.2L384.4,439.2z"
        />
        <polygon
          points="397.9,430.5 400.5,430.5 400.5,443.9 397.7,443.9 392.3,434.3 392.2,434.3 392.2,443.9 389.6,443.9
    389.6,430.5 392.6,430.5 397.9,439.8 397.9,439.8 397.9,430.5 	"
        />
        <polygon points="408.4,443.9 405.6,443.9 405.6,430.5 408.4,430.5 408.4,443.9 	" />
        <polygon
          points="419.3,443.9 416.5,443.9 416.5,432.9 412.5,432.9 412.5,430.5 423.4,430.5 423.4,432.9 419.3,432.9
    419.3,443.9 	"
        />
        <polygon
          points="433.9,443.9 431.1,443.9 431.1,438.8 426.5,430.5 429.8,430.5 432.6,436.3 435.2,430.5 438.4,430.5
    433.9,438.9 433.9,443.9 	"
        />
        <path
          d="M358.7,270.8l-90.1,44.4V336h10.1v62.5H438V336h12.1v-20.8L358.7,270.8L358.7,270.8z M418.5,379.7H298.2v-57.1
    l60.5-30.9l59.8,30.9V379.7L418.5,379.7z"
        />
        <polygon points="386.3,342.7 330.5,342.7 330.5,322.6 386.3,322.6 386.3,342.7 	" />
        <polygon points="386.3,371.7 330.5,371.7 330.5,351.5 386.3,351.5 386.3,371.7 	" />
      </g>
    </svg>
  )
}

export default EHOIcon
